import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Toolbar,
  Typography } from
"@mui/material";
import {
  ClientSideRowModelModule } from
'ag-grid-community';
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useLingui } from '@lingui/react';
import { msg } from '@lingui/macro';
import httpReq from "../ce-services/http-req";
import { ActionsToolBar } from "../components/grid/ActionsToolbar";
import ImagesSlider from "../components/images/ImageSlider";
import FirstPage from "../components/reportFormPages/FirstPage";
import FourthPage from "../components/reportFormPages/FourthPage";
import SecondPage from "../components/reportFormPages/SecondPage";
import ThirdPage from "../components/reportFormPages/ThirdPage";
import useOnlineStatus from "../hooks/useOnlineStatus";
import { getPublicAccidentDrafts, removeFromIndexedDB } from "../utils";
import ModalManageDraft from '../components/modals/reportAccident/ModalManageDraft';
import { getMapCenter } from '../config/market';

const CENTER = getMapCenter();
// LON, LAT Rome - This should be capital of the state
const ZOOM = 10;

const ReportAccidentNew = ({ isMobile }) => {
  const { _ } = useLingui();
  const { control, setValue, getValues, handleSubmit, watch, handlePicture, register, getFieldState, reset } = useForm();
  const RenderRegion = (props) => {
    let selectedRow = props.node.data;
    const foundRegion = regions.find((r) => r.id === selectedRow.publicAccident.regionFk);

    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Typography sx={{ marginTop: 1 }}>{foundRegion?.name}</Typography>
            </Box>);

  };
  const ToolbarTable = (props) => {
    let selectedRow = props.node.data;

    const viewAction = () => {
      setRowToView(selectedRow);
      setisModalViewDraftOpen(true);
    };

    const customActions = [
    {
      action: viewAction,
      disabled: false,
      icon: 'view',
      label: _(msg`View report`),
      tooltip: _(msg`View report`)
    }];



    return <ActionsToolBar customActions={customActions} />;
  };
  const initColumns = [
  {
    field: 'publicAccident.longitude',
    headerName: _(msg`Longitude`),
    flex: 1
  },
  {
    field: 'publicAccident.latitude',
    headerName: _(msg`Latitude`),
    flex: 1
  },
  {
    headerName: _(msg`Region`),
    flex: 3,
    cellRenderer: RenderRegion
  },
  {
    headerName: _(msg`Data`),
    field: 'publicAccident.data',
    flex: 5
  },
  { headerName: _(msg`Actions`), cellRenderer: ToolbarTable, flex: !isMobile ? 1 : 2 }];

  const geoControlRef = useRef();
  const [rowsData, setRowsData] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  //
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  //
  const [vehicleTypes, setVehicleTypes] = useState([]);
  //
  const [selectedSingleVehicle, setSelectedSingleVehicle] = useState(null);
  //
  const [draft, setDraft] = useState(null);
  const isOnline = useOnlineStatus();
  const [thirdPageRowsData, setThirdPageRowsData] = useState([]);
  const [images, setImages] = useState([]);
  //
  const [rowToView, setRowToView] = useState(null);
  const [isModalViewDraftOpen, setisModalViewDraftOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isViewAlert, setIsViewAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [dataSaved, setDataSaved] = useState(null);

  useEffect(() => {
    if (dataLoaded) {
      return;
    }
    if (isOnline) {
      getRegions();
      getVehicleTypes();
    } else {
      const region = localStorage.getItem('region');
      setRegions(JSON.parse(region));
      const vehicleTypes = localStorage.getItem('vehicleTypes');
      setVehicleTypes(JSON.parse(vehicleTypes));
    }
    setDataLoaded(true);
  }, [dataLoaded]);


  useEffect(() => {
    if (pageIndex === 0) {
      getRowsByIndexedDb();
    }
  }, [pageIndex]);

  useEffect(() => {

    getVehicleTypes();
  }, [dataSaved]);


  const getRowsByIndexedDb = async () => {
    const req = await getPublicAccidentDrafts();
    req.onsuccess = () => {
      const result = req.result;

      setRowsData(result);
    };
  };

  const resetVehiclesAdmount = () => {
    const v = [...vehicleTypes];
    v.map((vehicle) => {
      vehicle.admount = 0;
      return vehicle;
    });
    setVehicleTypes(v);
  };


  const getRegions = async () => {
    const res = await httpReq('Region/GetList', 'GET', null, false);
    if (!res.responseAnyError) {
      localStorage.setItem('regions', JSON.stringify(res.responseData));
      setRegions(res.responseData);
    }
  };

  const getVehicleTypes = async () => {
    const res = await httpReq('VehicleType/GetList', 'GET', null, false);
    if (!res.responseAnyError) {
      const mappedWithAdmount = res.responseData.map((vehicle) => {
        vehicle.admount = 0;
        return vehicle;
      });
      localStorage.setItem('vehicleTypes', JSON.stringify(mappedWithAdmount));

      setVehicleTypes(mappedWithAdmount);
    }
  };


  const HomePage = () => {
    return (
      <Container>
                <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 20 }}>
                    <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
                        <Typography variant="h7" sx={{ fontWeight: 700 }}>{_(msg`Drafts list`)}</Typography>
                        <Button variant="contained" onClick={() => {
              setPageIndex(pageIndex + 1);
              setDataSaved(false);
            }}>
                            <Typography sx={{ textTransform: 'none' }}>{_(msg`Report a Traffic Crash`)}</Typography>
                            <AddIcon />
                        </Button>
                    </Box>

                    <div style={{ height: '40vh', marginTop: 10 }}>
                        <AgGridReact modules={[ClientSideRowModelModule]} columnDefs={initColumns}
            rowData={rowsData}></AgGridReact>
                    </div>
                </Box>
            </Container>);

  };

  const regionNameFounded = (regionId) => {
    const regionFounded = regions.find((r) => r.id === regionId);
    if (regionFounded) {
      return regionFounded.name;
    }
  };
  return (
    <>
            <Toolbar sx={{ boxShadow: 1 }}>
                <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1
        }}>
                    <Box sx={{ display: 'flex', flex: 2 }}>
                        <Typography sx={{ fontWeight: 700 }}>{_(msg`Traffic crash reports`)}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flex: 1, gap: 3, alignItems: 'center', justifyContent: 'flex-end' }}>
                        <Typography>{isOnline ? '🟢' : '🔴'}</Typography>
                        <Typography>{isOnline ? _(msg`ONLINE`) : _(msg`OFFLINE`)}</Typography>
                    </Box>
                </Box>
            </Toolbar>
            {pageIndex === 0 && <HomePage />}
            {pageIndex === 1 &&
      <FirstPage
        resetForm={reset}
        getValues={getValues}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        control={control}
        geoControlRef={geoControlRef}
        isMobile={isMobile}
        CENTER={CENTER}
        ZOOM={ZOOM} />
      }
            {pageIndex === 2 &&
      <SecondPage
        getValues={getValues}
        control={control}
        selectedRegion={selectedRegion}
        setSelectedRegion={setSelectedRegion}
        regions={regions}
        pageIndex={pageIndex}
        isMobile={isMobile}
        setPageIndex={setPageIndex}
        draft={draft}
        setDraft={setDraft} />

      }
            {pageIndex === 3 &&
      <ThirdPage
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        draft={draft}
        setDraft={setDraft}
        isMobile={isMobile}
        selectedSingleVehicle={selectedSingleVehicle}
        setSelectedSingleVehicle={setSelectedSingleVehicle}
        vehicleTypes={vehicleTypes}
        rowsData={thirdPageRowsData}
        setRowsData={setThirdPageRowsData} />
      }
            {pageIndex === 4 &&
      <FourthPage
        setSelectedRegion={setSelectedRegion}
        resetForm={reset}
        setDataSaved={setDataSaved}
        isMobile={isMobile}
        images={images}
        draft={draft}
        pageIndex={pageIndex}
        setDraft={setDraft}
        isOnline={isOnline}
        setPageIndex={setPageIndex}
        setImages={setImages} />
      }
            {isModalViewDraftOpen &&
      <ModalManageDraft
        getRowsByIndexedDb={getRowsByIndexedDb}
        isOnline={isOnline}
        rowsData={rowsData}
        setIsViewAlert={setIsViewAlert}
        setAlertMessage={setAlertMessage}
        regionNameFounded={regionNameFounded}
        vehicleTypes={vehicleTypes}
        isMobile={isMobile} rowToManage={rowToView} setIsOpen={setisModalViewDraftOpen}
        isOpen={isModalViewDraftOpen} />
      }
            {isLoading && <Backdrop
        sx={{ color: '#fff', zIndex: 1000 }}
        open={isLoading}>

        
                <CircularProgress color="inherit" />
            </Backdrop>}
            {isViewAlert && <Alert sx={{ width: '80%', marginLeft: '10%' }} action={
      <Button onClick={() => {
        setIsViewAlert(false);
      }} color="inherit" size="small">
                    <CloseIcon />
                </Button>
      } severity="success">
                <Typography>{alertMessage}</Typography>
            </Alert>}
        </>);

};
export default ReportAccidentNew;